/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductProfitabilityFilter
 */
export interface ProductProfitabilityFilter {
    /**
     * Inclusive start date without a range-length limit.
     * @type {string}
     * @memberof ProductProfitabilityFilter
     */
    since?: string;
    /**
     * Inclusive end date without a range-length limit.
     * @type {string}
     * @memberof ProductProfitabilityFilter
     */
    until?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductProfitabilityFilter
     */
    selectedCentreIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductProfitabilityFilter
     */
    selectedDomainIds?: Array<string>;
    /**
     * 
     * @type {ProductProfitabilityFilterCustomerWholesaleEnum}
     * @memberof ProductProfitabilityFilter
     */
    customerWholesale?: ProductProfitabilityFilterCustomerWholesaleEnum | null;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityFilter
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityFilter
     */
    page?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductProfitabilityFilter
     */
    search?: string | null;
    /**
     * 
     * @type {ProductProfitabilityFilterModeEnum}
     * @memberof ProductProfitabilityFilter
     */
    mode?: ProductProfitabilityFilterModeEnum;
    /**
     * 
     * @type {ProductProfitabilityFilterSortByEnum}
     * @memberof ProductProfitabilityFilter
     */
    sortBy?: ProductProfitabilityFilterSortByEnum;
    /**
     * 
     * @type {ProductProfitabilityFilterOrderDirectionEnum}
     * @memberof ProductProfitabilityFilter
     */
    orderDirection?: ProductProfitabilityFilterOrderDirectionEnum;
}


/**
 * @export
 */
export const ProductProfitabilityFilterCustomerWholesaleEnum = {
    Wholesale: 'wholesale',
    NonWholesale: 'non_wholesale',
    Unknown: 'unknown'
} as const;
export type ProductProfitabilityFilterCustomerWholesaleEnum = typeof ProductProfitabilityFilterCustomerWholesaleEnum[keyof typeof ProductProfitabilityFilterCustomerWholesaleEnum];

/**
 * @export
 */
export const ProductProfitabilityFilterModeEnum = {
    Gross: 'gross',
    Net: 'net'
} as const;
export type ProductProfitabilityFilterModeEnum = typeof ProductProfitabilityFilterModeEnum[keyof typeof ProductProfitabilityFilterModeEnum];

/**
 * @export
 */
export const ProductProfitabilityFilterSortByEnum = {
    Product: 'product',
    ProfitAfterMarketing: 'profitAfterMarketing',
    GrossMargin: 'grossMargin',
    PurchasePrice: 'purchasePrice',
    AllocatedMarketingSpend: 'allocatedMarketingSpend',
    Turnover: 'turnover',
    Amount: 'amount',
    MarginPercent: 'marginPercent'
} as const;
export type ProductProfitabilityFilterSortByEnum = typeof ProductProfitabilityFilterSortByEnum[keyof typeof ProductProfitabilityFilterSortByEnum];

/**
 * @export
 */
export const ProductProfitabilityFilterOrderDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ProductProfitabilityFilterOrderDirectionEnum = typeof ProductProfitabilityFilterOrderDirectionEnum[keyof typeof ProductProfitabilityFilterOrderDirectionEnum];


/**
 * Check if a given object implements the ProductProfitabilityFilter interface.
 */
export function instanceOfProductProfitabilityFilter(value: object): value is ProductProfitabilityFilter {
    return true;
}

export function ProductProfitabilityFilterFromJSON(json: any): ProductProfitabilityFilter {
    return ProductProfitabilityFilterFromJSONTyped(json, false);
}

export function ProductProfitabilityFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductProfitabilityFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'since': json['since'] == null ? undefined : json['since'],
        'until': json['until'] == null ? undefined : json['until'],
        'selectedCentreIds': json['selectedCentreIds'] == null ? undefined : json['selectedCentreIds'],
        'selectedDomainIds': json['selectedDomainIds'] == null ? undefined : json['selectedDomainIds'],
        'customerWholesale': json['customerWholesale'] === undefined ? undefined : json['customerWholesale'] === null ? null : json['customerWholesale'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'page': json['page'] == null ? undefined : json['page'],
        'search': json['search'] === undefined ? undefined : json['search'] === null ? null : json['search'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'orderDirection': json['orderDirection'] == null ? undefined : json['orderDirection'],
    };
}

export function ProductProfitabilityFilterToJSON(json: any): ProductProfitabilityFilter {
    return ProductProfitabilityFilterToJSONTyped(json, false);
}

export function ProductProfitabilityFilterToJSONTyped(value?: ProductProfitabilityFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'since': value['since'],
        'until': value['until'],
        'selectedCentreIds': value['selectedCentreIds'],
        'selectedDomainIds': value['selectedDomainIds'],
        'customerWholesale': value['customerWholesale'],
        'limit': value['limit'],
        'page': value['page'],
        'search': value['search'],
        'mode': value['mode'],
        'sortBy': value['sortBy'],
        'orderDirection': value['orderDirection'],
    };
}

